import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

type Props = {
  searchData: (year: string) => void;
  targetDateList: string[],
  resetState: boolean,
  clearResetSatate: () => void;
}

export default function FiscalYear(props: Props) {
  const { searchData, targetDateList, resetState, clearResetSatate } = props;
  const [year, setYear] = React.useState('');

  const handleStartChange = (event: SelectChangeEvent) => {
    setYear(event.target.value as string);
  };
  
  React.useEffect(() => {
    setYear(`${targetDateList.length - 1}`);
  }, [targetDateList]);
  
  React.useEffect(() => {
    if (year === ""){
      searchData("");
    }
    else{
      searchData(targetDateList[Number(year)]);
    }
  }, [year]);

  React.useEffect(() => {
    if(resetState === true){
      setYear(`${targetDateList.length - 1}`);
      clearResetSatate();
    }
  }, [resetState]);

  return (
    <div>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={1}>
          <Typography className="c-search__select__title" variant="body1">対象年度</Typography>
        </Grid>
        <Grid item xs={1.5}>
          <FormControl size="small" fullWidth>
            <Select
              value={year}
              onChange={handleStartChange}
              MenuProps={{
                MenuListProps: {
                  style: {
                    maxHeight: "200px",
                    overflowY: "auto"
                  }
                }
              }}
            >
            {targetDateList.map((month, index) => (
                <MenuItem value={index}>{month}</MenuItem>
            ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </div>
  );
}